/**
 * A tenant subdomain has to be a single DNS label: letters, numbers and hyphens only,
 * starting and ending with a letter or number, 63 characters at most.
 *
 * The API normalises case and rejects anything else with a 400. Checking here as well
 * turns that into an inline error instead of a failed save.
 */
const SUBDOMAIN_PATTERN = /^[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?$/;

export const isValidSubdomain = (subdomain: string | undefined): boolean =>
  SUBDOMAIN_PATTERN.test((subdomain ?? "").trim().toLowerCase());
